var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[(_vm.isVisible)?_c('b-button',{staticClass:"f-110 back-to-top-circle py-0",attrs:{"variant":"gray"},on:{"click":_vm.backToTop}},[_c('fa',{attrs:{"icon":"angle-up"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }